<template>
  <SidebarLayoutContainer>
    <div id="ScrollableSidebar" class='mb-auto overflow-x-hidden overflow-y-auto'>
      <v-list
        class="ma-0 pa-0"
        v-for="(group, index) in listItems.filter((item) =>
          filteredPermission(item)
        )"
        :key="`sidebar_${index}`"
        style="background-color: rgba(0, 0, 0, 0)"
        dense
        v-scroll-to="`#sidebar_${index}`"
      >
        <SidebarListGroup
          v-if="group.childItems"
          :group="group"
          :id="`sidebar_${index}`"
        >
          <SidebarChildListItem
            v-for="item in group.childItems.filter((item) =>
              filteredPermission(item)
            )"
            :item="item"
            :key="`${item.label}_${item.link}`"
          />
        </SidebarListGroup>
        <SidebarListItem v-else :item="group" />
      </v-list>
    </div>
  </SidebarLayoutContainer>
</template>

<script>
import * as adminRoutes from '@/src/routers/admin'
import SidebarLayoutContainer from './Sidebar/SidebarLayoutContainer'
import { mapState } from 'vuex'
import SidebarListItem from '../../components/shared/SidebarLayout/SidebarListItem'
import SidebarChildListItem from '../../components/shared/SidebarLayout/SidebarChildListItem'
import SidebarListGroup from '../../components/shared/SidebarLayout/SidebarListGroup'
import SituationUtils from '@/mixins/situation_utils'
import SitePermissionUtils, { GLOSSARY_SITUATION_ID } from '@/mixins/site_permission_utils'

export default {
  name: 'AdminSidebarContainer',
  mixins: [SituationUtils, SitePermissionUtils],
  components: {
    SidebarListGroup,
    SidebarChildListItem,
    SidebarListItem,
    SidebarLayoutContainer
  },
  computed: {
    listItems () {
      return [
        {
          label: 'ホーム',
          link: { name: adminRoutes.adminDashboard },
          icon: 'mdi-home'
        },
        {
          label: '記事',
          icon: 'mdi-text-box',
          childItems: [
            { label: '記事一覧', link: { name: adminRoutes.adminPosts } },
            {
              label: 'レギュレーション',
              situation: this.situations.regulationCheckManagement,
              link: { name: adminRoutes.adminRegulationChecks }
            },
            {
              label: '記事グループ',
              situation: this.situations.postListManagement,
              link: { name: adminRoutes.adminPostGroups }
            },
            {
              label: '特集',
              situation: this.situations.featureManagement,
              link: { name: adminRoutes.adminFeatures }
            },
            {
              label: '画像',
              situation: this.situations.pictureManagement,
              link: { name: adminRoutes.adminPicture }
            },
            {
              label: 'キャラクター設定',
              situation: this.situations.characterImageManagement,
              link: { name: adminRoutes.adminCharacters }
            }
          ]
        },
        {
          label: 'デザイン',
          situation: this.situations.siteDesignConfiguration,
          link: { name: adminRoutes.adminDesigns },
          icon: 'mdi-palette'
        },
        {
          label: 'タグ管理',
          icon: 'mdi-tag-heart',
          childItems: [
            {
              label: 'タグ一覧',
              situation: this.situations.tagManagement,
              link: { name: adminRoutes.adminTags }
            },
            {
              label: 'タググループ',
              situation: this.situations.tagManagement,
              link: { name: adminRoutes.adminTagGroups }
            },
            {
              label: '一括タグ追加',
              situation: this.situations.tagManagement,
              link: { name: adminRoutes.adminTagsAssignment }
            }
          ]
        },
        {
          label: 'ウィジェット',
          situation: this.situations.widgetManagement,
          link: { name: adminRoutes.adminWidgets },
          icon: 'mdi-widgets'
        },
        {
          label: '静的ページ',
          icon: 'mdi-note-multiple',
          childItems: [
            {
              label: '固定ページ',
              situation: this.situations.mediaPageManagement,

              link: { name: adminRoutes.adminMediaPages }
            },
            {
              label: 'HTMLページ',
              situation: this.situations.htmlPageManagement,
              link: { name: adminRoutes.adminHtmlPages }
            }
          ]
        },
        {
          label: 'ギャラリー',
          situation: this.situations.exhibitManagement,
          link: { name: adminRoutes.adminExhibitManagement },
          icon: 'mdi-image-multiple'
        },
        {
          label: 'メルマガ',
          icon: 'mdi-email',
          childItems: [
            {
              label: '会員',
              situation: this.situations.mailMagazineMemberManagement,
              link: { name: adminRoutes.adminMailMagazineMember }
            },
            {
              label: '設定',
              situation: this.situations.mailMagazineMemberManagement,
              link: { name: adminRoutes.adminMailMagazineSettings, params: { service: 'onamae' } }
            }
          ]
        },
        {
          label: '商品',
          situation: this.situations.productManagement,
          link: { name: adminRoutes.adminProducts },
          icon: 'mdi-cart'
        },
        {
          label: '用語集',
          situation: this.situations.glossaryManagement,
          siteSituationId: GLOSSARY_SITUATION_ID,
          link: { name: adminRoutes.adminGlossary },
          icon: 'mdi-book-alphabet'
        },
        {
          label: 'ユーザー',
          icon: 'mdi-account-multiple',
          childItems: [
            {
              label: '管理者',
              situation: this.situations.adminManagement,
              link: { name: adminRoutes.adminAdminUsers }
            },
            {
              label: 'ライター',
              situation: this.situations.writerManagement,
              link: { name: adminRoutes.adminWriters }
            },
            {
              label: '寄稿者',
              situation: this.situations.contributorManagement,
              link: { name: adminRoutes.adminContributors }
            },
            {
              label: '監修者',
              situation: this.situations.expertManagement,
              link: { name: adminRoutes.adminExperts }
            }
          ]
        },
        {
          label: '発注',
          icon: 'mdi-account-edit',
          childItems: [
            {
              label: '発注一覧',
              link: { name: adminRoutes.adminOrders },
              situation: this.situations.orderManagement
            },
            {
              label: '一括発注登録',
              situation: this.situations.orderManagement,
              link: { name: adminRoutes.adminOrderRegistrations }
            }
          ]
        },
        {
          label: 'お問い合わせ',
          icon: 'mdi-email',
          situation: this.situations.contactManagement,
          link: { name: adminRoutes.adminContacts }
        },
        {
          label: '設定',
          icon: 'mdi-cog',
          childItems: [
            { label: 'サイト設定', situation: this.situations.siteConfiguration, link: { name: adminRoutes.adminSettings } },
            { label: 'RSS設定', situation: this.situations.siteConfiguration, link: { name: adminRoutes.adminRssSettings } },
            {
              label: 'リダイレクト設定',
              situation: this.situations.siteConfiguration,
              link: { name: adminRoutes.adminMediaRedirections }
            },
            {
              label: 'フッターリンク',
              situation: this.situations.footerLinkManagement,
              link: { name: adminRoutes.adminFooterLinks }
            }
          ]
        }
      ]
    },
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    filteredPermission (item) {
      if (item.siteSituationId) {
        return this.isPermitted(item.siteSituationId)
      }

      if (item.childItems) {
        return item.childItems.filter(this.filteredPermission).length > 0
      }

      if (item.situation) {
        return this.currentUser.permittedSituations.includes(item.situation)
      }

      return !!this.currentUser.permittedSituations
    }
  }
}
</script>
